import { useAuthStore } from '../../features/auth/authStore';

const getInitials = (name: string) => {
  if (!name) return '';
  const [firstName, lastName] = name.split(' ');
  if (!firstName || !lastName) return '';
  return `${firstName[0]}${lastName[0]}`;
};

const Profile = () => {
  const user = useAuthStore((state) => state.auth);
  const initials = getInitials(user?.displayName || '');
  return (
    <a
      href="#"
      className="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold text-gray-900 hover:bg-gray-50"
    >
      {user?.photoURL ? (
        <img
          alt="User"
          src={user?.photoURL || 'https://randomuser.com/api/port'}
          className="size-8 rounded-full bg-gray-50"
        />
      ) : (
        <span className="flex size-8 shrink-0 items-center justify-center rounded-full border bg-gray-50 text-[0.625rem] font-medium border-gray-200 text-gray-500 group-hover:border-indigo-600 group-hover:text-indigo-600">
          {initials}
        </span>
      )}
      <span aria-hidden="true">{user?.displayName || 'Jane Doe'}</span>
    </a>
  );
};

export default Profile;
